import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode } from "vue";
import _imports_0 from '@/assets/images/laba.png';
const _hoisted_1 = {
  class: "tac"
};
const _hoisted_2 = {
  class: "mt-4 m-4 title tac"
};
const _hoisted_3 = {
  class: "mt-4 m-4 title tac"
};
const _hoisted_4 = {
  class: "tac"
};
const _hoisted_5 = {
  class: "tac"
};
const _hoisted_6 = {
  class: "tac"
};
const _hoisted_7 = {
  key: 0,
  class: "mt-4 m-4 title tac"
};
const _hoisted_8 = {
  key: 1,
  class: "mt-4 m-4 title tac"
};
const _hoisted_9 = {
  class: "tac"
};
const _hoisted_10 = {
  class: "mt-4 m-4 title tac"
};
const _hoisted_11 = {
  class: "mt-4 m-4 title tac"
};
const _hoisted_12 = {
  class: "tac"
};
const _hoisted_13 = {
  class: "mt-4 m-4 title tac"
};
const _hoisted_14 = {
  class: "mt-4 m-4 title tac"
};
const _hoisted_15 = {
  class: "button"
};
import useAppStore from '@views/app.store';
import { Warning } from '@element-plus/icons-vue';
export default /*@__PURE__*/_defineComponent({
  __name: 'authDialog',
  setup(__props) {
    const appStore = useAppStore();
    const goAuthentication = () => {
      location.href = process.env.VUE_APP_NAV_TOP_URL + '/userCenter/authentication/fastAuthentication';
    };
    return (_ctx, _cache) => {
      const _component_el_icon = _resolveComponent("el-icon");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_dialog = _resolveComponent("el-dialog");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_component_el_dialog, {
        modelValue: _unref(appStore).authenticationDialog,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _unref(appStore).authenticationDialog = $event),
        title: "提示",
        "close-on-click-modal": false,
        class: "dialog-m-col",
        "append-to-body": true
      }, {
        footer: _withCtx(() => [_createVNode(_component_el_button, {
          size: "small",
          onClick: _cache[0] || (_cache[0] = $event => _unref(appStore).authenticationDialog = false)
        }, {
          default: _withCtx(() => [...(_cache[15] || (_cache[15] = [_createTextVNode("下次再说", -1)]))]),
          _: 1
        }), _createVNode(_component_el_button, {
          size: "small",
          type: "primary",
          onClick: goAuthentication
        }, {
          default: _withCtx(() => [...(_cache[16] || (_cache[16] = [_createTextVNode("重新认证", -1)]))]),
          _: 1
        })]),
        default: _withCtx(() => [_createElementVNode("p", _hoisted_1, [_createVNode(_component_el_icon, null, {
          default: _withCtx(() => [_createVNode(_unref(Warning))]),
          _: 1
        })]), _unref(appStore).authenticationOvertime ? (_openBlock(), _createElementBlock(_Fragment, {
          key: 0
        }, [_createElementVNode("p", _hoisted_2, "营业执照已于" + _toDisplayString(_unref(appStore).overtime) + "到期啦,部分功能已暂停使用", 1), _cache[13] || (_cache[13] = _createElementVNode("p", {
          class: "m-4 tac"
        }, "实名认证中的营业执照已到期，为避免对您造成影响，请尽快重新上传！", -1))], 64)) : (_openBlock(), _createElementBlock(_Fragment, {
          key: 1
        }, [_createElementVNode("p", _hoisted_3, "营业执照将于" + _toDisplayString(_unref(appStore).overtime) + "到期,届时部分功能将暂停使用", 1), _cache[14] || (_cache[14] = _createElementVNode("p", {
          class: "m-4 tac"
        }, "实名认证中的营业执照即将到期，为避免对您造成影响，请尽快重新上传！", -1))], 64))]),
        _: 1
      }, 8, ["modelValue"]), _createVNode(_component_el_dialog, {
        modelValue: _unref(appStore).unAuthencationDialog,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => _unref(appStore).unAuthencationDialog = $event),
        title: "提示",
        "close-on-click-modal": false,
        class: "dialog-m-col",
        "append-to-body": true
      }, {
        footer: _withCtx(() => [_createVNode(_component_el_button, {
          size: "small",
          onClick: _cache[2] || (_cache[2] = $event => _unref(appStore).unAuthencationDialog = false)
        }, {
          default: _withCtx(() => [...(_cache[17] || (_cache[17] = [_createTextVNode("下次再说", -1)]))]),
          _: 1
        }), _createVNode(_component_el_button, {
          size: "small",
          type: "primary",
          onClick: goAuthentication
        }, {
          default: _withCtx(() => [...(_cache[18] || (_cache[18] = [_createTextVNode("立即认证", -1)]))]),
          _: 1
        })]),
        default: _withCtx(() => [_createElementVNode("p", _hoisted_4, [_createVNode(_component_el_icon, null, {
          default: _withCtx(() => [_createVNode(_unref(Warning))]),
          _: 1
        })]), _cache[19] || (_cache[19] = _createElementVNode("p", {
          class: "mt-4 title tac"
        }, "为保证账号及资产的安全，请先实名认证", -1)), _cache[20] || (_cache[20] = _createElementVNode("p", {
          class: "mt-4 m-4 tac"
        }, "实名认证决定了账号的归属，部分功能需实名认证后才可使用", -1))]),
        _: 1
      }, 8, ["modelValue"]), _createVNode(_component_el_dialog, {
        modelValue: _unref(appStore).authencationLimitDialog,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => _unref(appStore).authencationLimitDialog = $event),
        title: "提示",
        "close-on-click-modal": false,
        class: "dialog-m-col",
        "append-to-body": true
      }, {
        footer: _withCtx(() => [_createVNode(_component_el_button, {
          size: "small",
          onClick: _cache[4] || (_cache[4] = $event => _unref(appStore).authencationLimitDialog = false)
        }, {
          default: _withCtx(() => [...(_cache[21] || (_cache[21] = [_createTextVNode("下次再说", -1)]))]),
          _: 1
        }), _createVNode(_component_el_button, {
          size: "small",
          type: "primary",
          onClick: goAuthentication
        }, {
          default: _withCtx(() => [...(_cache[22] || (_cache[22] = [_createTextVNode("重新认证", -1)]))]),
          _: 1
        })]),
        default: _withCtx(() => [_createElementVNode("p", _hoisted_5, [_createVNode(_component_el_icon, null, {
          default: _withCtx(() => [_createVNode(_unref(Warning))]),
          _: 1
        })]), _cache[23] || (_cache[23] = _createElementVNode("p", {
          class: "mt-4 title tac"
        }, "您提交的实名认证审核未通过，请尽快重新提交", -1)), _cache[24] || (_cache[24] = _createElementVNode("p", {
          class: "mt-4 m-4 tac"
        }, "实名认证审核未通过，为避免影响您的正常使用，请尽快重新提交", -1))]),
        _: 1
      }, 8, ["modelValue"]), _createVNode(_component_el_dialog, {
        modelValue: _unref(appStore).realNameDialog,
        "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => _unref(appStore).realNameDialog = $event),
        title: "提示",
        "close-on-click-modal": false,
        class: "dialog-m-col",
        "append-to-body": true
      }, {
        footer: _withCtx(() => [_createVNode(_component_el_button, {
          size: "small",
          onClick: _cache[6] || (_cache[6] = $event => _ctx.realNameDialog = false)
        }, {
          default: _withCtx(() => [...(_cache[25] || (_cache[25] = [_createTextVNode("下次再说", -1)]))]),
          _: 1
        }), _createVNode(_component_el_button, {
          size: "small",
          type: "primary",
          onClick: goAuthentication
        }, {
          default: _withCtx(() => [...(_cache[26] || (_cache[26] = [_createTextVNode("重新认证", -1)]))]),
          _: 1
        })]),
        default: _withCtx(() => [_createElementVNode("p", _hoisted_6, [_createVNode(_component_el_icon, null, {
          default: _withCtx(() => [_createVNode(_unref(Warning))]),
          _: 1
        })]), _ctx.authenticationOvertime ? (_openBlock(), _createElementBlock("p", _hoisted_7, "实名认证已于" + _toDisplayString(_unref(appStore).realNameOvertime) + "到期,部分功能已暂停使用", 1)) : (_openBlock(), _createElementBlock("p", _hoisted_8, "实名认证将于" + _toDisplayString(_unref(appStore).realNameOvertime) + "到期,届时部分功能将暂停使用", 1)), _cache[27] || (_cache[27] = _createElementVNode("p", {
          class: "m-4 tac"
        }, "实名认证有效期为1年，为避免对您造成影响，请尽快重新认证！", -1))]),
        _: 1
      }, 8, ["modelValue"]), _createVNode(_component_el_dialog, {
        modelValue: _unref(appStore).legalRepreDialog,
        "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => _unref(appStore).legalRepreDialog = $event),
        title: "提示",
        "close-on-click-modal": false,
        class: "dialog-m-col",
        "append-to-body": true
      }, {
        footer: _withCtx(() => [_createVNode(_component_el_button, {
          size: "small",
          onClick: _cache[8] || (_cache[8] = $event => _unref(appStore).legalRepreDialog = false)
        }, {
          default: _withCtx(() => [...(_cache[30] || (_cache[30] = [_createTextVNode("下次再说", -1)]))]),
          _: 1
        }), _createVNode(_component_el_button, {
          size: "small",
          type: "primary",
          onClick: goAuthentication
        }, {
          default: _withCtx(() => [...(_cache[31] || (_cache[31] = [_createTextVNode("重新认证", -1)]))]),
          _: 1
        })]),
        default: _withCtx(() => [_createElementVNode("p", _hoisted_9, [_createVNode(_component_el_icon, null, {
          default: _withCtx(() => [_createVNode(_unref(Warning))]),
          _: 1
        })]), _unref(appStore).authenticationOvertime ? (_openBlock(), _createElementBlock(_Fragment, {
          key: 0
        }, [_createElementVNode("p", _hoisted_10, "法人身份证已于" + _toDisplayString(_unref(appStore).overtime) + "到期,部分功能已暂停使用", 1), _cache[28] || (_cache[28] = _createElementVNode("p", {
          class: "m-4 tac"
        }, "实名认证中的法人身份证已到期，为避免对您造成影响，请尽快重新上传！", -1))], 64)) : (_openBlock(), _createElementBlock(_Fragment, {
          key: 1
        }, [_createElementVNode("p", _hoisted_11, "法人身份证将于" + _toDisplayString(_unref(appStore).overtime) + "到期,届时部分功能将暂停使用", 1), _cache[29] || (_cache[29] = _createElementVNode("p", {
          class: "m-4 tac"
        }, "实名认证中的法人身份证即将到期，为避免对您造成影响，请尽快重新上传！", -1))], 64))]),
        _: 1
      }, 8, ["modelValue"]), _createVNode(_component_el_dialog, {
        modelValue: _unref(appStore).idcardDialog,
        "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => _unref(appStore).idcardDialog = $event),
        title: "提示",
        "close-on-click-modal": false,
        class: "dialog-m-col",
        "append-to-body": true
      }, {
        footer: _withCtx(() => [_createVNode(_component_el_button, {
          size: "small",
          onClick: _cache[10] || (_cache[10] = $event => _unref(appStore).idcardDialog = false)
        }, {
          default: _withCtx(() => [...(_cache[34] || (_cache[34] = [_createTextVNode("下次再说", -1)]))]),
          _: 1
        }), _createVNode(_component_el_button, {
          size: "small",
          type: "primary",
          onClick: goAuthentication
        }, {
          default: _withCtx(() => [...(_cache[35] || (_cache[35] = [_createTextVNode("重新认证", -1)]))]),
          _: 1
        })]),
        default: _withCtx(() => [_createElementVNode("p", _hoisted_12, [_createVNode(_component_el_icon, null, {
          default: _withCtx(() => [_createVNode(_unref(Warning))]),
          _: 1
        })]), _ctx.authenticationOvertime ? (_openBlock(), _createElementBlock(_Fragment, {
          key: 0
        }, [_createElementVNode("p", _hoisted_13, "个人身份证已于" + _toDisplayString(_unref(appStore).overtime) + "到期,部分功能已暂停使用", 1), _cache[32] || (_cache[32] = _createElementVNode("p", {
          class: "m-4 tac"
        }, "实名认证中的个人身份证已到期，为避免对您造成影响，请尽快重新上传！", -1))], 64)) : (_openBlock(), _createElementBlock(_Fragment, {
          key: 1
        }, [_createElementVNode("p", _hoisted_14, "个人身份证将于" + _toDisplayString(_unref(appStore).overtime) + "到期,届时部分功能将暂停使用", 1), _cache[33] || (_cache[33] = _createElementVNode("p", {
          class: "m-4 tac"
        }, "实名认证中的个人身份证即将到期，为避免对您造成影响，请尽快重新上传！", -1))], 64))]),
        _: 1
      }, 8, ["modelValue"]), _createVNode(_component_el_dialog, {
        "close-on-click-modal": false,
        modelValue: _unref(appStore).showAuthenticationDialog,
        "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => _unref(appStore).showAuthenticationDialog = $event),
        width: "640px",
        center: "",
        class: "tip-container",
        "show-close": false,
        onClose: goAuthentication
      }, {
        title: _withCtx(() => [...(_cache[36] || (_cache[36] = [_createElementVNode("h3", null, "亲/爱/的/小/主/请/悉/知", -1), _createElementVNode("img", {
          src: _imports_0,
          class: "laba",
          alt: ""
        }, null, -1)]))]),
        default: _withCtx(() => [_cache[38] || (_cache[38] = _createElementVNode("div", {
          class: "tac"
        }, [_createElementVNode("h6", null, "请先进行企业认证！!"), _createElementVNode("p", {
          class: "mt-4"
        }, "实名认证决定了账号的归属"), _createElementVNode("p", null, "部分功能需要实名认证后才能使用")], -1)), _createElementVNode("p", _hoisted_15, [_createVNode(_component_el_button, {
          size: "",
          type: "primary",
          round: "",
          onClick: goAuthentication
        }, {
          default: _withCtx(() => [...(_cache[37] || (_cache[37] = [_createTextVNode("现在就去", -1)]))]),
          _: 1
        })])]),
        _: 1
      }, 8, ["modelValue"])], 64);
    };
  }
});